import { render, staticRenderFns } from "./accomodations.vue?vue&type=template&id=4509c29e&scoped=true&"
import script from "./accomodations.vue?vue&type=script&lang=js&"
export * from "./accomodations.vue?vue&type=script&lang=js&"
import style0 from "./accomodations.vue?vue&type=style&index=0&id=4509c29e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4509c29e",
  null
  
)

export default component.exports